module.exports = __webpack_public_path__ + "static/media/curvas.a178f2bf.png";